import { createFileRoute } from "@tanstack/react-router";
import { monthSearchSchema } from "../-lib/month-search-schema";



export const Route = createFileRoute("/_protected/dashboard/staff-performance/")({
  head: () => ({
    meta: [{ title: "教练绩效排行榜 · imiker CRM" }],
  }),
  validateSearch: monthSearchSchema
});
